export enum DataGridColumnType {
    Select = 'select',
    TimeDate = 'timeDate',
}
